module.exports = __webpack_public_path__ + "static/img/2h.541cb6ef.png";